<template>
    <div id="loginType" v-show="loginType">
        <div class="auth-modal-box">

            <el-form ref="form" :model="form" :rules="rules" label-width="" class="auth-form">
                <div class="panfish">
                    <img src="http://foo.ibianma.com/jingying/word/2018/11/12/995c9ba92886246315283735291ca2b4.png"
                    class="normal" style="width: 13rem;">
                </div>
                <i title="关闭" class="el-icon-circle-close close-btn" @click="closeBtn"></i>
                <h1 class="title">
                        登录
                    </h1>
                <el-form-item label="" prop="mobile">
                    <el-input v-model="form.mobile"  maxlength="64" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="" prop="sendcode">
                    <el-input v-model="form.sendcode" type="password" id="password" maxlength="64" placeholder="请输入短信验证码" class="" style="">
                        <template slot="append">
                            <el-button type="primary" @click="getCode" >{{codeContent}}</el-button>
                        </template>
                    </el-input>
                </el-form-item>

                <el-form-item label="">
                    <el-button type="primary" style="width: 100%;" @click="login">登录</el-button>
                </el-form-item>
             
            </el-form>

        </div>
    </div>
</template>

<script>

    import { loginCode} from '@/api'
    import store from '@/store'

    export default {
        name: "loginType",
        data() {
            return {
                codeContent:"获取验证码",
                sendType:true,
                form:{
                    login_type: 'YZM',
                    area_code: 86,
                    mobile: '',
                    sendcode: '',
                    role:'1'
                },
                rules: { // 验证条件
                    sendcode: [
                        { required: true, message: '请输入验证码', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: '请输入正确的电话', trigger: 'change,blur' }
                    ]
                }
            }
        },
        computed: {
            loginType() {
                return this.$store.state.user.loginType
            }
        },
        methods: {
            getCode()
            {

                var that = this
                if(this.sendType == true)
                {
                    loginCode(this.form).then(response => {
                        
                    })

                    this.sendType = false
                    var i = 59
                    var codeTimeInterVal = setInterval(function(){
                        if(i > 0){
                            var text = i +"秒"
                            that.codeContent = text
                        }else{
                            that.sendType = true
                            that.codeContent = "重新发送"
                            clearInterval(codeTimeInterVal);
                            return;
                        }
                        i--;
                    }, 1000);
                }
                return;
            },
            closeBtn()
            {
                store.dispatch('user/setLoginType', false);
            },
            login()
            {

                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        store.dispatch('user/login', this.form);
                    }
                })
                
            }

        },
        watch: {
            loginType: {
                immediate: true,
                handler: (n, o) => {
                    let htmlBodyElement = document.querySelector('body');
                    htmlBodyElement.style.overflowY = n ? 'hidden' : 'auto';
                }
            }
        }
    }
</script>

<style scoped>

 .login {
        height:50px;
        line-height: 50px;
        padding-left:10px;
        cursor: pointer;
    }
    
    .auth-modal-box {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,.3);
        z-index: 1001;
    }
    
    .auth-modal-box .btn {
        width: 100%;
        height: 46px;
        color: #fff;
        background-color: #007fff;
        border-radius: 2px;
        outline: none;
        box-sizing: border-box;
        cursor: pointer;
    }
    .auth-form {
        position: relative;
        padding: 24px;
        width: 320px;
        max-width: 100%;
        font-size: 14px;
        background-color: #fff;
        border-radius: 2px;
        box-sizing: border-box;
    }

        .panfish .normal {
        position: absolute;
        top: 0;
        left: 50%;
        width: 10rem;
        -webkit-transform: translate(-50%,-83%);
        transform: translate(-50%,-83%);
        z-index: 1;
    }
    
    .panfish .greeting {
        position: absolute;
        top: 0;
        left: 50%;
        width: 10rem;
        -webkit-transform: translate(-50%,-75.8%);
        transform: translate(-50%,-75.8%);
        z-index: 1;
    }
    
    .panfish .blindfold {
        position: absolute;
        top: 0;
        left: 50%;
        width: 8.6rem;
        -webkit-transform: translate(-50%,-75%);
        transform: translate(-50%,-75%);
        z-index: 1;
    }
    
    .close-btn {
        float: right;
        cursor: pointer;
        opacity: .4;
    }

    
    .title {
        font-size: 1.1rem;
        margin: 0 0 1rem;
    }
    
    /* .btn {
        width: 100%;
        height: 3.334rem;
        color: #fff;
        background-color: #007fff;
        border-radius: 2px;
        outline: none;
        box-sizing: border-box;
        cursor: pointer;
    } */
    
    .prompt-box {
        margin: 1rem 0 0;
        color: #8b9196;
    }
    
    .oauth-box .oauth-bg, .oauth-box .oauth{
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .oauth-box .oauth {
        -ms-flex-pack: distribute;
        justify-content: space-around;
        margin-top: 15px;
    }
    .oauth-box {
        margin-top: 1.2rem;
        line-height: 1.9rem;
        color: #8b9196;
    }
    .oauth-box .oauth {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    
    .oauth-box .oauth-bg {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        background-color: #f4f8fb;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
    
    .oauth-box .oauth-btn {
        height: 1.9rem;
        vertical-align: bottom;
        cursor: pointer;
    }
    .oauth-box img {
        border-style: none;
    }
    
    .input-box {
        position: relative;
        margin-bottom: 15px;
    }
    .input {
        padding: 10px;
        width: 272px;
        border: 1px solid #e9e9e9;
        border-radius: 2px;
        outline: none;
        box-sizing: border-box;
    }
    .min-width {
        min-width: 1200px;
    }
    #nav .menu-item {
        float: left;
    }
    .nav-right {
        float: right;
    }
    .nav-left {
        float: left;
    }
    #searchform {
        padding-top:8px;
    }
    .user-info {
        display: none;
        height:50px;
        line-height: 50px;
        padding-left:10px;
        cursor: pointer;
    }




    #loading {
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #F9F9F9;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loader {
        box-sizing: border-box;
        display: flex;
        flex: 0 1 auto;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 0;
        flex-basis: 25%;
        max-width: 25%;
        height: 200px;
        align-items: center;
        justify-content: center;
    }

    .la-pacman, .la-pacman > div {
        position: relative;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box
    }

    .la-pacman {
        display: block;
        font-size: 0;
        color: #d81e06;
    }

    .la-pacman.la-dark {
        color: #333
    }

    .la-pacman > div {
        display: inline-block;
        float: none;
        background-color: currentColor;
        border: 0 solid currentColor
    }

    .la-pacman {
        width: 32px;
        height: 32px
    }

    .la-pacman > div:nth-child(1), .la-pacman > div:nth-child(2) {
        width: 0;
        height: 0;
        background: transparent;
        border-style: solid;
        border-width: 16px;
        border-right-color: transparent;
        border-radius: 100%;
        -webkit-animation: pacman-rotate-half-up 0.5s 0s infinite;
        -moz-animation: pacman-rotate-half-up 0.5s 0s infinite;
        -o-animation: pacman-rotate-half-up 0.5s 0s infinite;
        animation: pacman-rotate-half-up 0.5s 0s infinite
    }

    .la-pacman > div:nth-child(2) {
        margin-top: -32px;
        -webkit-animation-name: pacman-rotate-half-down;
        -moz-animation-name: pacman-rotate-half-down;
        -o-animation-name: pacman-rotate-half-down;
        animation-name: pacman-rotate-half-down
    }

    .la-pacman > div:nth-child(3), .la-pacman > div:nth-child(4), .la-pacman > div:nth-child(5), .la-pacman > div:nth-child(6) {
        position: absolute;
        top: 50%;
        left: 200%;
        width: 8px;
        height: 8px;
        border-radius: 100%;
        opacity: 0;
        -webkit-animation: pacman-balls 2s 0s infinite linear;
        -moz-animation: pacman-balls 2s 0s infinite linear;
        -o-animation: pacman-balls 2s 0s infinite linear;
        animation: pacman-balls 2s 0s infinite linear
    }

    .la-pacman > div:nth-child(3) {
        -webkit-animation-delay: -1.44s;
        -moz-animation-delay: -1.44s;
        -o-animation-delay: -1.44s;
        animation-delay: -1.44s
    }

    .la-pacman > div:nth-child(4) {
        -webkit-animation-delay: -1.94s;
        -moz-animation-delay: -1.94s;
        -o-animation-delay: -1.94s;
        animation-delay: -1.94s
    }

    .la-pacman > div:nth-child(5) {
        -webkit-animation-delay: -2.44s;
        -moz-animation-delay: -2.44s;
        -o-animation-delay: -2.44s;
        animation-delay: -2.44s
    }

    .la-pacman > div:nth-child(6) {
        -webkit-animation-delay: -2.94s;
        -moz-animation-delay: -2.94s;
        -o-animation-delay: -2.94s;
        animation-delay: -2.94s
    }

    .la-pacman.la-sm {
        width: 16px;
        height: 16px
    }

    .la-pacman.la-sm > div:nth-child(1), .la-pacman.la-sm > div:nth-child(2) {
        border-width: 8px
    }

    .la-pacman.la-sm > div:nth-child(2) {
        margin-top: -16px
    }

    .la-pacman.la-sm > div:nth-child(3), .la-pacman.la-sm > div:nth-child(4), .la-pacman.la-sm > div:nth-child(5), .la-pacman.la-sm > div:nth-child(6) {
        width: 4px;
        height: 4px
    }

    .la-pacman.la-2x {
        width: 64px;
        height: 64px
    }

    .la-pacman.la-2x > div:nth-child(1), .la-pacman.la-2x > div:nth-child(2) {
        border-width: 32px
    }

    .la-pacman.la-2x > div:nth-child(2) {
        margin-top: -64px
    }

    .la-pacman.la-2x > div:nth-child(3), .la-pacman.la-2x > div:nth-child(4), .la-pacman.la-2x > div:nth-child(5), .la-pacman.la-2x > div:nth-child(6) {
        width: 16px;
        height: 16px
    }

    .la-pacman.la-3x {
        width: 96px;
        height: 96px
    }

    .la-pacman.la-3x > div:nth-child(1), .la-pacman.la-3x > div:nth-child(2) {
        border-width: 48px
    }

    .la-pacman.la-3x > div:nth-child(2) {
        margin-top: -96px
    }

    .la-pacman.la-3x > div:nth-child(3), .la-pacman.la-3x > div:nth-child(4), .la-pacman.la-3x > div:nth-child(5), .la-pacman.la-3x > div:nth-child(6) {
        width: 24px;
        height: 24px
    }

    @-webkit-keyframes pacman-rotate-half-up {
        0%, 100% {
            -webkit-transform: rotate(270deg);
            transform: rotate(270deg)
        }
        50% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg)
        }
    }

    @-moz-keyframes pacman-rotate-half-up {
        0%, 100% {
            -moz-transform: rotate(270deg);
            transform: rotate(270deg)
        }
        50% {
            -moz-transform: rotate(360deg);
            transform: rotate(360deg)
        }
    }

    @-o-keyframes pacman-rotate-half-up {
        0%, 100% {
            -o-transform: rotate(270deg);
            transform: rotate(270deg)
        }
        50% {
            -o-transform: rotate(360deg);
            transform: rotate(360deg)
        }
    }

    @keyframes pacman-rotate-half-up {
        0%, 100% {
            -webkit-transform: rotate(270deg);
            -moz-transform: rotate(270deg);
            -o-transform: rotate(270deg);
            transform: rotate(270deg)
        }
        50% {
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg)
        }
    }

    @-webkit-keyframes pacman-rotate-half-down {
        0%, 100% {
            -webkit-transform: rotate(90deg);
            transform: rotate(90deg)
        }
        50% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg)
        }
    }

    @-moz-keyframes pacman-rotate-half-down {
        0%, 100% {
            -moz-transform: rotate(90deg);
            transform: rotate(90deg)
        }
        50% {
            -moz-transform: rotate(0deg);
            transform: rotate(0deg)
        }
    }

    @-o-keyframes pacman-rotate-half-down {
        0%, 100% {
            -o-transform: rotate(90deg);
            transform: rotate(90deg)
        }
        50% {
            -o-transform: rotate(0deg);
            transform: rotate(0deg)
        }
    }

    @keyframes pacman-rotate-half-down {
        0%, 100% {
            -webkit-transform: rotate(90deg);
            -moz-transform: rotate(90deg);
            -o-transform: rotate(90deg);
            transform: rotate(90deg)
        }
        50% {
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg)
        }
    }

    @-webkit-keyframes pacman-balls {
        0% {
            left: 200%;
            opacity: 0;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%)
        }
        5% {
            opacity: .5
        }
        66% {
            opacity: 1
        }
        67% {
            opacity: 0
        }
        100% {
            left: 0;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%)
        }
    }

    @-moz-keyframes pacman-balls {
        0% {
            left: 200%;
            opacity: 0;
            -moz-transform: translateY(-50%);
            transform: translateY(-50%)
        }
        5% {
            opacity: .5
        }
        66% {
            opacity: 1
        }
        67% {
            opacity: 0
        }
        100% {
            left: 0;
            -moz-transform: translateY(-50%);
            transform: translateY(-50%)
        }
    }

    @-o-keyframes pacman-balls {
        0% {
            left: 200%;
            opacity: 0;
            -o-transform: translateY(-50%);
            transform: translateY(-50%)
        }
        5% {
            opacity: .5
        }
        66% {
            opacity: 1
        }
        67% {
            opacity: 0
        }
        100% {
            left: 0;
            -o-transform: translateY(-50%);
            transform: translateY(-50%)
        }
    }

    @keyframes pacman-balls {
        0% {
            left: 200%;
            opacity: 0;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%)
        }
        5% {
            opacity: .5
        }
        66% {
            opacity: 1
        }
        67% {
            opacity: 0
        }
        100% {
            left: 0;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%)
        }
    }
</style>